import React, {useState} from 'react';
import Link from 'next/link';
import NavbarLinks from './NavbarLinks';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import UserTab from './UserTab';
import Image from 'next/image';
import CookieConsent from '../cookie/CookieConsent';
import MobileMenu from './MobileMenu';
import styles from '../styles/header/Navbar.module.scss';
import CartTab from './cart/CartTab';

const ConsoNavbar = (props) => {
    const {menu, selected, cart} = props;
    const [isOpen, editIsOpen] = useState(false);
    const toggleMobileMenu = () => {
        if (!isOpen) {
            document.querySelector("body").classList.add('mobile-menu');
        } else {
            document.querySelector("body").classList.remove('mobile-menu');
        }
        editIsOpen(!isOpen);
    }
    const closeMenu = () => {
        editIsOpen(false); document.querySelector("body").classList.remove('mobile-menu');
    }
    
    return (
        <>
            <CookieConsent />
            <Navbar className="main-nav"  expand="lg">
                <Link href={process.env.NEXT_PUBLIC_WEB}>
                    <Navbar.Brand target="_blank" className={`ms-lg-3 me-auto d-flex align-items-center ${styles.logo}`} >
                        <Image src="/images/icons/conso.png" width={111} height={33}  alt="Conso" />  
                    </Navbar.Brand>
                </Link>
                
                <Navbar.Toggle 
                    aria-controls="basic-navbar-nav" 
                    className="order-2" 
                    onClick={toggleMobileMenu} 
                /> 
                <CartTab cart={cart} />
                <UserTab /> 

                <Navbar.Collapse id="basic-navbar-nav" className="order-lg-1 order-2 d-none d-lg-block">
                    <Container className="d-flex justify-content-lg-center">
                        <NavbarLinks menuList={menu} selected={selected} />
                    </Container>
                </Navbar.Collapse>
                
            </Navbar>
            {isOpen && 
            <MobileMenu 
                menuList={menu}
                closeMenu={closeMenu}
            />}
        </>
    );
}

export default ConsoNavbar;